import { getFieldAlias } from 'api';
import { FieldTemplate, LayoutItem } from 'api/models';
import { getId } from 'utils';
import { getSampleFields, usedAliases } from './sample-fields';
import { getSampleLayout } from './sample-layout';

export async function getSampleData({ projectId }: { projectId: string }) {
  const items = getSampleLayout().map(i => ({ ...i })) as LayoutItem[];
  const fields = updateItems(items as LayoutItem[]).map(f => ({ ...f }));
  const aliasPromises = fields.map(async f => {
    const alias = await getFieldAlias({
      projectId,
      usedAliases,
      title: f.alias,
    });

    f.alias = alias;

    return f;
  });

  let updatedAliases = await Promise.all(aliasPromises);

  const statusAlias = updatedAliases.find(f =>
    f.alias.includes('statusz'),
  )?.alias;

  if (statusAlias) {
    updatedAliases = updatedAliases.map(f => {
      if (f.isVisible) {
        // @ts-ignore
        f.isVisible.conditions[0].conditions[0].reference.alias = statusAlias;
      }
      return f;
    });
  }

  return {
    items,
    fields: updatedAliases,
  };
}

function updateItems(layout: LayoutItem[]) {
  let fields = [] as FieldTemplate[];
  layout.forEach(i => {
    if (i.children) {
      const fs = updateItems(i.children);
      if (fs) {
        fields = [...fields, ...fs];
      }
    }
    const updatedField = updateItem(i);
    if (updatedField) {
      fields.push(updatedField);
    }
  });
  return fields;
}

function updateItem(item: LayoutItem): FieldTemplate | undefined {
  const itemId = getId();
  const fieldId = getId();
  item.id = itemId;
  if (item.fieldTemplateId) {
    const field = getSampleFields().find(t => t.id === item.fieldTemplateId);
    if (field) {
      item.fieldTemplateId = fieldId;

      return {
        ...field,
        formFieldTemplateId: itemId,
        id: fieldId,
      } as FieldTemplate;
    }
  }
}
